<template>
  <div>
    <h1 v-if="currentYear">{{ currentYear.year.Title }} Ballot </h1>
    <ul class="list-group ballot-list">
      <li v-for="category in currentYearCategories" :key="category['.key']" class="list-group-item">
        <div>
          <img src="../images/oscar-statue.png">
        </div>
        <div v-if="isAuthenticated">
          <h3 class="d-inline-block">{{ category.name }}</h3>
          <ul class="nominee-list" v-if="category.nominees">
            <li v-for="(nominee, index) in category.nominees" :key="index">
              <label>
                <input
                  :disabled="votingDeactivated"
                  type="radio"
                  :name="category['.key']"
                  @click="castVote(category['.key'], index)"
                  :checked="authUser && currentYear.year.votes && currentYear.year.votes[authUser.uid] && index === currentYear.year.votes[authUser.uid][category['.key']]"
                > <span>{{ nominee.nomineeName }} - <b>{{ nominee.nomineeMovie }}</b></span></label>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import firebase from 'firebase';
import sharedMixin from '../mixins/shared';

export default {
  name: 'Ballot',
  mixins: [sharedMixin],
  methods: {
    castVote(category, nominee) {
      const userID = firebase.auth().currentUser.uid;

      if (!this.currentYear.year.votes) {
        this.currentYear.year.votes = {
          [userID]: {
            [category]: nominee
          }
        };
      } else if (!this.currentYear.year.votes[userID]) {
        this.currentYear.year.votes[userID] = {
          [category]: nominee
        };
      } else {
        this.currentYear.year.votes[userID][category] = nominee;
      };

      this.$firebaseRefs.oscarYears.child(this.currentYear['.key']).child('year').child('votes').set(this.currentYear.year.votes);
    }
  },
  computed: {
    votingDeactivated() {
      if(this.currentYear) {
        return this.currentYear.deactivated;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '../sass/config';

  .ballot-list {
    margin-bottom: 50px;

    > li {
      display: grid;
      grid-template-columns: 50px auto;
    }

    div:first-child {
      padding: 25px 10px;
      text-align: center;
    }
    div:last-child {
      padding: 25px 25px 0;
    }
  }
  .nominee-list {
    list-style-type: none;
    margin: 25px 0 0;
    padding: 0;

    @include breakpoint(md) {
      display: grid;
      grid-template-columns: 50% 50%;
    }

    li {
      margin: 0 0 25px;
      input {
        display: none;
      }
      span {
        display: inline-block;
        padding-left: 30px;
        position: relative;
      }
      span::before {
        border: 2px solid rgba(0, 0, 0, 0.125);
        border-radius: 50%;
        content: '';
        height: 20px;
        left: 0;
        position: absolute;
        top: 3px;
        width: 20px;
      }
      input:checked ~ span::before {
        background-color: $gold;
      }
    }

    @include breakpoint(md) {
      li:nth-child(odd) {
        padding-right: 35px;
      }
      li:nth-child(even) {
        padding-left: 25px;
      }
    }
  }
</style>
